import api from '../../../api';
import { finish, error } from '../../../modules/roles/actions/delete';

export function request(dispatch, { id }) {
    api.del(`/roles/${id}`).then(
        response => dispatch(finish(response)),
        ({ errors }) => dispatch(error(errors))
    );
}
